module.exports = __webpack_public_path__ + "media/svgs/PDF-Icon-white-a27e1d3d9b99a4f66e017077536dcf25.svg";